import React, { FC, useCallback, useEffect, useRef, ChangeEvent } from 'react';
import { InputAdornment, TextFieldProps } from '@mui/material';
import { IntlShape } from 'react-intl';
import * as Styled from './ProjectsSearchInput.styles';
import { definedTranslation } from '../../../../../../i18n';

type ProjectsSearchInputProps = TextFieldProps & {
  value?: string;
  onInputChange?: (value: string) => void;
  intl: IntlShape;
};

export const ProjectsSearchInput: FC<ProjectsSearchInputProps> = (props) => {
  const { value, onInputChange, intl, ...inputProps } = props;

  const inputRef = useRef<HTMLInputElement | null>(null);

  const handleTextFieldChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      onInputChange?.(event.target.value);
    },
    [onInputChange],
  );

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  const onClearClick = useCallback(() => {
    onInputChange?.('');
  }, [onInputChange]);

  const startAdornment = (
    <InputAdornment position="end">
      <Styled.SearchIcon />
    </InputAdornment>
  );

  const endAdornment = (
    <InputAdornment position="end">
      <Styled.CloseIcon onClick={onClearClick} />
    </InputAdornment>
  );

  return (
    <Styled.Field
      inputRef={inputRef}
      onChange={handleTextFieldChange}
      value={value}
      autoComplete="off"
      // @ts-expect-error // TODO: fix types
      variant="outlined"
      placeholder={
        intl?.formatMessage(definedTranslation.searchProjectsLabel) || 'Search'
      }
      fullWidth
      size="small"
      InputProps={{
        startAdornment,
        endAdornment: value ? endAdornment : null,
      }}
      {...inputProps}
    />
  );
};
